import { createI18n } from 'vue-i18n'

// 定义中英文语言包
const messages = {
  'zh-CN': {
    header: {
      home: '首页',
      features: '功能',
      blog: '博客',
      download: '下载',
      buy: '购买',
      token: 'Token套餐',
      contact: '联系我们',
      user:"用户",
      edit_profile: '修改信息',
      order_center: '订单中心'
    },
    features: {
      title: '核心功能',
      subtitle: 'Omni-note 的核心能力，让你的知识管理工作流彻底升级',
      heroTitle: '强大功能，开箱即用',
      heroSubtitle: '数据不出设备，从知识生产到内容生成，全链路可信可控',

      agentEngine: '九种结构化产出引擎',
      agentEngineDesc: '知识库检索结果不只是文字回答——Omni-note 内置 9 种结构化产出引擎：研究报告、思维导图、学习闪卡、测验题、信息图、Wiki 文章、PPT 大纲、音频播客、视频。上传资料、提问，AI 直接生成可交付的结构化内容，从知识到产出一步到位。',
      agentEngineHighlight: '报告 / 思维导图 / 闪卡 / 测验 / 信息图 / Wiki / PPT / 播客 / 视频，一键生成交付物',
      rag: 'Graph RAG 智能知识库',
      ragDesc: '上传文档（PDF、Word、Markdown、代码等），AI 自动解析、索引，构建专属知识库。采用 Graph RAG 三路 RRF 融合检索——BM25 关键词 + 向量检索 + 知识图谱（实体抽取 + 社区聚类），配合 ReAct Agent 智能编排（自动拆解复杂问题、多步推理、动态调用 MCP 工具），精准定位信息，回答自带出处引用，杜绝 AI 幻觉。',
      ragHighlight: '三路 RRF 融合 + ReAct Agent 智能编排，精准度远超传统 RAG',

      multimodal: '多模态 AI 处理',
      multimodalDesc: '支持文本、图像、语音、视频全类型数据。本地图像生成、语音转写、视频帧分析，打破单一模态的限制。',
      multimodalHighlight: '一台普通电脑，搞定图文音视全场景',

      mcp: '智能体无限扩展平台',
      mcpDesc: '基于 MCP（Model Context Protocol）协议，连接 5000+ 智能体。需要数据分析、代码审查、财务报表、智能客服？安装对应 Agent 即刻使用，无需开发。',
      mcpHighlight: '你的需求，不是功能的边界',

      notes: '智能笔记管理',
      notesDesc: 'Markdown 编辑器 + 多级分组树 + 模板系统，构建完整的知识组织体系。支持回收站、全文搜索，轻松找到答案。',
      notesHighlight: '结构化组织，随查随用，知识不再零散',

      security: '私有化安全部署',
      securityDesc: '100% 本地部署，数据不出你的电脑。数据库端到端加密，无云端泄露风险。适合金融、医疗、科研等敏感场景。',
      securityHighlight: '数据安全，不是信念是架构',

      deploy: '灵活部署架构',
      deployDesc: 'C/S 架构支持三种模式：个人电脑单机使用、局域网内团队协作、云端混合部署。跨平台（Windows/macOS/Linux）无缝同步。',
      deployHighlight: '一个平台，适配你的所有设备',

      api: '标准化 API 兼容',
      apiDesc: '统一接口适配行业主流服务：OpenAI API 格式、FUNASR 语音识别、Stable Diffusion 图像生成、Jina AI 重排模型。无缝集成现有生态。',
      apiHighlight: '不锁定供应商，自由切换模型',

      cta: '准备好体验了吗？',
      ctaDesc: '免费下载，立即体验全链路安全可信的 AI 知识平台',
    },
    download: {
      title: '下载 Omni-note',
      subtitle: '立即开始使用我们的AI生产力平台',
      chooseVersion: '选择版本',
      selectEdition: '为您的需求选择合适的版本',
      personalEdition: '个人版',
      enterpriseEdition: '企业版',
      personalDownload: '个人版下载',
      personalDesc: '适用于个人用户和小型团队的免费版本',
      enterpriseDownload: '企业版下载',
      enterpriseDesc: '适用于企业用户的高级版本，提供更多功能和支持',
      choosePlatform: '选择您的平台',
      downloadFor: '下载适用于',
      windows: 'Windows',
      macos: 'macOS',
      linux: 'Linux',
      windowsDesc: 'Windows 10 或更高版本',
      macosDesc: 'macOS 10.15 或更高版本',
      linuxDesc: 'Ubuntu 20.04 或更高版本',
      systemRequirements: '系统要求',
      windowsRequirements: 'Windows 系统要求',
      macosRequirements: 'macOS 系统要求',
      linuxRequirements: 'Linux 系统要求',
      minRam: '最低 4 GB 内存',
      processor: '2 GHz 处理器或更快',
      diskSpace: '1 GB 磁盘空间(不包括模型文件)',
      enterpriseFeatures: '企业版功能',
      enterpriseTitle: '企业版',
      advancedSecurity: '高级安全保障',
      multiUserSupport: '多用户支持',
      centralizedManagement: '集中管理',
      dedicatedSupport: '专属技术支持',
      osRequirements: '支持系统',
      hardwareRequirements: '硬件要求',
      needMore: '需要更多功能或定制化服务？',
      contactSales: '联系销售团队'
    },
    home: {
      // ===== Hero =====
      title: 'Omni-note',
      subtitle: '全链路安全可信的 AI 知识平台',
      heroDesc: '本地版数据不出本机，云端版开箱即用——从知识生产到内容生成，全链路可信可控',
      download: '免费下载',
      watchDemo: '看演示',
      contactUs: '联系我们',

      // ===== 版本选择 =====
      editionsTitle: '两种版本，按需选择',
      editionsSubtitle: '功能一致，数据位置与付费方式不同；两种版本均为原生中文界面',
      localTitle: '本地版',
      localTag: '数据不出本机',
      localDesc: '模型与推理全部运行在你的电脑上，适合离线使用或对数据保密有要求的场景。',
      localFeature1: '数据与推理全程留在本机',
      localFeature2: '可离线使用，不依赖外部网络',
      localFeature3: '按会员方案区分每月用量',
      localFeature4: '需自行下载模型并配置推理环境',
      localCta: '查看本地版',
      cloudTitle: '云端版',
      cloudTag: '开箱即用',
      cloudDesc: '软件免费，模型按 Token 用量充值，适合轻设备或想快速上手的用户。',
      cloudFeature1: '下载即用，无需本地模型与推理环境',
      cloudFeature2: '调用 api.turingevo.com 云端模型',
      cloudFeature3: '无每月调用次数限制，按实际用量计费',
      cloudFeature4: '不占用本地算力，轻设备也能用',
      cloudCta: '查看云端版',

      // ===== 三大核心卖点 =====
      valueTitle: '为什么选择 Omni-note？',
      valueSubtitle: '全链路安全可信——知识生产 · 知识管理 · 内容生成，覆盖知识工作的完整闭环',

      valueRag: 'Graph RAG 可信知识库',
      valueRagDesc: '上传文档，AI 自动阅读、索引、问答。Graph RAG 三路 RRF 融合检索（BM25 关键词 + 向量检索 + 知识图谱（实体抽取 + 社区聚类）），配合 ReAct Agent 智能编排——复杂问题自动拆解、多步推理，精准度远超传统单一向量检索。回答自带清晰出处引用，所见所得，所得必有据。',
      valueRagStat: 'BM25 + 向量 + 知识图谱 · 三路 RRF 融合 · ReAct Agent · 引用可追溯',

      valuePrivate: '本地私有化部署',
      valuePrivateDesc: '数据不出你的电脑，数据库端到端加密，无云端泄露风险。纯 CPU 即可流畅运行，无需昂贵 GPU——一台普通笔记本足矣。',
      valuePrivateStat: '端侧算力加速 · 端到端加密 · 节省 70%+ 算力成本',

      valueMcp: '全模态 + 智能体无限扩展',
      valueMcpDesc: '支持文本、图像、语音、视频全类型 AI 处理（本地文生图、语音转写、视频帧分析）。基于 MCP 协议连接 5000+ 智能体，按需扩展，无需开发。',
      valueMcpStat: '图文音视全模态 · 5000+ 智能体 · 即装即用',

      // ===== 演示视频 =====
      demoTitle: '3 分钟看懂 Omni-note',
      demoSubtitle: '从资料导入到九种产出，完整流程真实录屏',
      demoCaption: '视频为中文旁白，英文版本制作中。',

      // ===== 九种产出 =====
      outputsTitle: '不止问答，直接交付成果',
      outputsSubtitle: '上传资料，AI 自动生成 9 种结构化产出——从研究报告到播客、视频，一步到位',
      outputReport: '研究报告',
      outputReportDesc: '基于知识库检索与引用，生成可溯源的深度报告',
      outputMindmap: '思维导图',
      outputMindmapDesc: '把主题拆成分支结构，一眼看清知识脉络',
      outputPpt: 'PPT 大纲',
      outputPptDesc: '按演示逻辑组织要点，直接进入制作',
      outputWiki: 'Wiki 知识库',
      outputWikiDesc: '沉淀结构化知识条目，支持多级目录',
      outputAudio: '播客',
      outputAudioDesc: '双人对谈式音频，通勤路上也能吸收资料',
      outputVideo: '视频',
      outputVideoDesc: '自动生成旁白与画面，把资料讲成视频',
      outputQuiz: '测验',
      outputQuizDesc: '按资料出题并附答案解析，检验掌握程度',
      outputCards: '闪卡',
      outputCardsDesc: '正反面知识卡，适合记忆与复习',
      outputInfographic: '信息图',
      outputInfographicDesc: '把关键数据与关系整理成可视化图表',

      // ===== 版本对比 =====
      versionComparison: '版本对比',
      chooseBestPlan: '为你的需求选择合适版本',

      features: '功能',
      communityEdition: '社区版',
      enterpriseEdition: '企业版',
      membershipEdition: '会员版',

      openSourceLicense: '许可证',
      openSource: '免费',
      commercialLicense: '商业许可证',
      cost: '费用',
      freePersonal: '个人免费',
      oneTimePurchase: '¥19/月 或 ¥119/年',
      deployment: '部署',
      singleMachine: '单机部署',
      privateDeployment: '私有化部署',

      function: '功能',
      basicFeatures: '基础功能',
      modelManagement: '模型管理',
      employeeManagement: '用户管理',
      sharedKnowledge: '共享知识库',
      dataBackup: '数据备份',
      permissionControl: '权限管理',

      technicalSupport: '技术支持',
      communitySupport: '社区支持',
      dedicatedSupport: '专职支持服务',

      systemSupport: '系统支持',
      win10Plus: 'Windows 10+, macOS, Linux',
      win7Plus: 'Windows 7+, macOS, Linux',

      // ===== 场景案例 =====
      useCases: '使用场景',
      useCasesDesc: 'Omni-note 如何为你和你的团队提效',
      case1: '📚 学习',
      case1Desc: '从被动阅读到主动消化',
      case1Detail: '上传课件、教材和笔记，AI 自动整理重点、生成问答复习卡，支持语义化查询，让知识真正变成你的。',
      case2: '🔬 研究',
      case2Desc: '从查找信息到产出洞察',
      case2Detail: '上传研究文献，跨文档语义检索秒级定位关键信息，AI 自动综述、追溯引用，告别 AI 幻觉，加速文献综述和报告生成。',
      case3: '💼 销售',
      case3Desc: '从调研到准备提案',
      case3Detail: '上传客户资料、产品文档、竞品分析，AI 整理客户画像，智能体辅助生成提案大纲和销售话术，让你赢在准备。',
      case4: '🎯 客服',
      case4Desc: '从帮助文档到自助答疑',
      case4Detail: '把帮助中心文章、产品文档、常见问题注入知识库，构建私有 RAG 系统，员工和客户都能快速找到答案。',
      case5: '🚀 团队上岗',
      case5Desc: '从手册到互动培训',
      case5Detail: '把员工手册、SOP、培训视频整合到共享知识库，新员工随问随答，HR 和管理层节省大量重复回答时间。',
      case6: '✍️ 内容创作',
      case6Desc: '从素材到多模态成果',
      case6Detail: '上传素材，本地图像生成、语音转写、视频帧分析一站式搞定，把灵感快速变成文章、配图、研究报告、思维导图、PPT 大纲、播客和视频。',

      // ===== CTA =====
      ctaTitle: '准备好拥有 Omni-note 了吗？',
      ctaDesc: '注册即用，免费体验全部核心功能',
      ctaStart: '立即开始',
      ctaContact: '预约演示',

      honor: '荣誉与行业认可',
      honorDesc: '四项赛事横跨 ARM/Intel/Qualcomm 三大芯片阵营，端侧AI技术获行业一致认可',
      honorArm: 'ARM 2024 人工智能创新应用大赛 · 优秀奖',
      honorIntel: 'Intel 2025 人工智能创新应用大赛 · 优胜奖',
      honorLenovo: '联想冠名顶级赞助商 · 特别奖',
      honorQualcomm: '高通骁龙 2025 人工智能创新应用大赛 · 优秀奖',
      heroCardTitle: 'Omni-note',
      heroCardAi1: '已分析你上传的 24 份文档，可以开始提问了',
      heroCardYou: '你',
      heroCardQuestion: '这篇论文的核心结论是什么？',
      heroCardAnswer: '根据《2025 AI Trends》第 3.2 节，核心结论是……',
      heroCardSource: '📄 来源：2025_AI_Trends.pdf → 第3章 → 第2节',
    },
    purchase: {
      title: '选择适合你的版本',
      subtitle: '云端版开箱即用，软件免费、模型按量充值；本地版数据与推理全部留在本机',
      // ===== 版本形态 =====
      editionsTitle: '两种版本，按需选择',
      editionsSubtitle: '云端版下载即用，模型调用按量付费；本地版自行部署模型，数据不出本机。',
      cloudTitle: '云端版',
      cloudTag: '推荐 · 无需本地模型',
      cloudDesc: '软件永久免费，模型调用按 Token 用量在 API 平台充值。',
      cloudFeature1: '下载即用，无需安装推理引擎或下载模型',
      cloudFeature2: '调用 api.turingevo.com 云端模型',
      cloudFeature3: '无每月调用次数限制，按实际用量计费',
      cloudFeature4: '支持 Linux，Windows / macOS 即将推出',
      cloudDownload: '前往 GitHub 下载',
      cloudRecharge: '前往 API 平台充值',
      localTitle: '本地版',
      localTag: '数据全部本地',
      localPrice: '会员制',
      localDesc: '模型与推理引擎运行在本机，适合离线或对数据保密有要求的场景。',
      localFeature1: '本地模型，数据不出本机',
      localFeature2: '会员方案按每月用量上限区分',
      localFeature3: '需要下载模型并配置推理环境',
      localFeature4: '提供社区版 / 基础版 / 专业版 / 企业版',
      localViewPlans: '查看本地版会员方案',

      // ===== 公共 =====
      free: '免费',
      buyNow: '立即购买',
      contactSales: '联系销售',
      custom: '定制',
      monthlyLabel: '月付',
      yearlyLabel: '年付',

      // ===== 社区版 =====
      communityTitle: '社区版',
      communityDesc: '适用于个人项目',
      communityFeature1: '3 个知识库 · 每库 50 份文档',
      communityFeature2: '图像生成 30 次/月',
      communityFeature3: '语音转写 25 次/月',
      communityFeature4: '视频分析 20 次/月',
      communityFeature5: '基础智能体 3 个',
      communityFeature6: '高级导出 5 次/月',
      communityFeature7: '社区支持',
      downloadNow: '免费下载',

      // ===== 基础版 =====
      basicTitle: '基础版',
      basicPrice: '¥9.9',
      basicOriginalPrice: '¥19',
      basicPerMonth: '/月',
      basicDesc: '适用于主动学习和深入研究',
      basicFeature1: '5 个知识库 · 每库 80 份文档',
      basicFeature2: '图像生成 100 次/月',
      basicFeature3: '语音转写 75 次/月',
      basicFeature4: '视频分析 60 次/月',
      basicFeature5: '基础智能体 10 个',
      basicFeature6: '高级导出 15 次/月',
      basicFeature7: '社区支持',

      // ===== 专业版 =====
      proTitle: '专业版',
      proBadge: '最受欢迎',
      proDesc: '适用于最专业的项目和高级用户',
      proMonthly: '¥19',
      proYearly: '¥119',
      proPerMonth: '/月',
      proPerYear: '/年',
      proMonthlyOriginal: '¥39',
      proYearlyOriginal: '¥199',
      proSave: '省 ¥109',
      proFeature1: '知识库/文档 无限量',
      proFeature2: '图像/语音/视频 无限量',
      proFeature3: '智能体 无限量',
      proFeature4: '高级导出 无限量',
      proFeature5: '优先支持',

      // ===== 企业版 =====
      enterpriseTitle: '企业版',
      enterpriseDesc: '团队协作、私有部署、专属支持',
      enterpriseFeature1: '无限制用户和设备',
      enterpriseFeature2: '共享知识库 · 权限管理',
      enterpriseFeature3: '本地/局域网/云端三模式',
      enterpriseFeature4: '专属客户经理',
      enterpriseFeature5: '24/7 高级支持 + 定制开发',

      // ===== 对比表 =====
      editionCompareTitle: '云端版 vs 本地版',
      editionCompareSubtitle: '两种版本功能一致，模型来源、费用方式与用量限制不同。',
      compareItem: '对比项',
      compareModelSource: '模型来源',
      compareCloudModelSource: '云端 API（api.turingevo.com）',
      compareLocalModelSource: '本机推理（本地模型）',
      compareCost: '费用方式',
      compareCloudCost: '软件免费，模型按 Token 用量充值',
      compareLocalCost: '会员订阅 + 本地硬件成本',
      compareUsageLimit: '每月用量限制',
      compareCloudUsage: '无限制，按实际用量计费',
      compareLocalUsage: '按会员方案区分（见下表）',
      compareSetup: '部署方式',
      compareCloudSetup: '下载即用',
      compareLocalSetup: '需配置本地模型与推理引擎',

      localPlansTitle: '本地版会员方案',
      localPlansNote: '以下每月用量限制仅适用于本地版；云端版不限制本地功能使用次数，模型费用按 API 用量计算。',
      compareTitle: '本地版方案对比',
      compareSubtitle: '以下限制仅适用于本地版，云端版不受这些用量限制。',
      features: '功能',
      ragBasic: 'RAG 知识库',
      modelSwitch: '模型切换',
      knowledgeBaseCount: '知识库数量',
      docPerKb: '每库文档数',
      imageGen: '图像生成',
      audioTranscribe: '语音转写',
      videoAnalyze: '视频分析',
      agentCount: '智能体个数',
      advancedExport: '高级导出',
      teamCollab: '团队协作',
      sharedKb: '共享知识库',
      userMgmt: '用户管理',
      support: '支持级别',
      unlimited: '∞',
      limitImageGen: '30 次/月',
      limitAudioTranscribe: '25 次/月',
      limitVideoAnalyze: '20 次/月',
      limitExportGen: '5 次/月',
      limitAgent: '3 个',
      basicExport: '基础格式',
      basicLimitImageGen: '100 次/月',
      basicLimitAudioTranscribe: '75 次/月',
      basicLimitVideoAnalyze: '60 次/月',
      basicLimitExportGen: '15 次/月',
      basicLimitAgent: '10 个',

      // ===== CTA =====
      ctaTitle: '企业用户，定制专属方案',
      ctaSubtitle: '预约演示，了解 Omni-note 如何为你的团队提效',
      requestDemo: '预约演示',

      // ===== 常见问题 =====
      faqTitle: '常见问题',
      faqQ1: '本地版的免费版、基础版和专业版有什么区别？',
      faqA1: '本地版各方案功能一致，差别只在每月用量：免费版图像 30 次、语音 25 次、视频 20 次；基础版分别为 100/75/60 次；专业版完全不限。云端版没有这些限制，模型费用按 API 用量在 api.turingevo.com 充值。',
      faqQ2: '如何从免费版升级？',
      faqA2: '点击"立即购买"即可升级本地版会员。现在订阅享发布特惠价（专业版 ¥39 → ¥19）。',
      faqQ3: '云端版和本地版应该怎么选？',
      faqA3: '想开箱即用、按实际用量付费，选云端版（软件免费，在 API 平台充值即可）；需要离线使用或数据必须留在本机，选本地版（需自行下载模型并配置推理环境，按会员方案使用）。',
    },
    contact: {
      title: '联系我们',
      subtitle: '与我们的团队取得联系',
      getInTouch: '取得联系',
      wedLove: '我们很乐意收到您的消息',
      contactInfo: '联系信息',
      name: '名称',
      details: '详情',
      qqGroup: 'QQ群',
      telegram: 'Telegram 群',
      website: '官网',
      email: '邮箱',
      blog: '博客',
      csdn: 'CSDN',
      github: 'GitHub',
      huggingface: 'Hugging Face',
      enterpriseWechat: '企业微信',
      officialAccount: '微信公众号',
      videoChannel: '视频号',
      sendMessage: '发送消息',
      fillForm: '填写以下表格，我们会尽快回复您',
      yourName: '您的姓名',
      yourEmail: '您的邮箱',
      subject: '主题',
      message: '消息',
      send: '发送消息',
      sending: '发送中...'
    },
    footer: {
      description: 'Omni-note 是全链路安全可信的 AI 知识平台——本地版数据不出本机，云端版开箱即用，从知识生产到内容生成，全链路可信可控。',
      socialLinks: '社交媒体',
      product: '产品',
      documentation: '文档',
      feedback: '反馈',
      friendlyLinks: '友情链接',
      contactUs: '联系我们',
      officialAccount: '官方微信公众号',
      questions: '如有任何问题，可先查看文档或在社区提问。或发送邮件至',
      copyright: 'Copyright © 2026 深圳市进化图灵智能科技有限公司 turingevo.com'
    },
    register: {
      title: '用户注册',
      username: '用户名',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      company: '公司',
      placeholder_username: '请输入用户名',
      placeholder_email: '请输入邮箱',
      placeholder_password: '请输入密码',
      placeholder_confirm_password: '请再次输入密码',
      placeholder_company: '请输入公司名称（可选）',
      register: '注册',
      registering: '注册中...',
      already_have_account: '已有账户？',
      login_now: '立即登录',
      error_user_exists: '该用户名或邮箱已被注册，请选择其他用户名或邮箱',
      error_password_length: '密码长度至少为6个字符',
      error_invalid_email: '请输入有效的邮箱地址',
      error_generic: '注册失败，请稍后重试',
      error_password_mismatch: '两次输入的密码不一致',
      error_missing_fields: '用户名、邮箱和密码是必填项',
      error_server_internal: '服务器内部错误'
    },
    login: {
      title: '用户登录',
      email: '邮箱',
      password: '密码',
      placeholder_email: '请输入邮箱',
      placeholder_password: '请输入密码',
      login: '登录',
      logging_in: '登录中...',
      dont_have_account: '还没有账户？',
      register_now: '立即注册',
      error_user_not_found: '该用户不存在，请先注册',
      error_password_wrong: '密码错误，请重新输入',
      error_generic: '登录失败，请稍后重试',
      registration_success: '注册成功！请登录。'
    },
    profile: {
      title: '个人中心',
      logout: '退出登录',
      user_info: '用户信息',
      username: '用户名',
      email: '邮箱',
      company: '公司',
      license_info: '许可证信息',
      license_type: '许可证类型',
      license_community: '社区版',
      license_basic: '基础版',
      license_pro: '专业版',
      license_enterprise: '企业版',
      status: '状态',
      active: '有效',
      inactive: '无效',
      expiry_date: '到期时间',
      devices: '设备数',
      license_key: '许可证密钥',
      show_key: '显示密钥',
      hide_key: '隐藏密钥',
      copy_key: '复制密钥',
      upgrade_to_enterprise: '升级到企业版',
      no_license: '暂无许可证信息',
      unknown: '未知',
      features: '功能列表',
      usage_info: '用量信息',
      usage_image_gen: '图像生成',
      usage_speech_asr: '语音转写',
      usage_video_analyze: '视频分析',
      usage_report_gen: '研究报告',
      usage_mindmap_gen: '思维导图',
      usage_cards_gen: '闪卡',
      usage_quiz_gen: '测验',
      usage_infographic_gen: '信息图',
      usage_ppt_gen: 'PPT',
      usage_podcast_gen: '音频',
      usage_wiki_gen: 'Wiki',
      usage_video_gen: '视频',
      usage_unlimited: '不限',
      usage_times: '次',
      usage_of: '/',
      usage_agent_limit: '智能体',
      usage_kb_limit: '知识库',
      usage_doc_limit: '每库文档',
      usage_limit_unit: '个',
      usage_doc_unit: '篇',
      feat_basic_note: '基础笔记',
      feat_rag_basic: '基础RAG',
      feat_rag_medium: '进阶RAG',
      feat_rag_pro: '专业RAG',
      feat_image_gen: '图像生成',
      feat_speech_asr: '语音转写',
      feat_agent_basic: '基础智能体',
      feat_agent_medium: '进阶智能体',
      feat_agent_pro: '专业智能体',
      feat_premium_support: '专属支持',
      feat_team_collab: '团队协作',
      feat_shared_kb: '共享知识库',
      feat_user_mgmt: '用户管理',
      feat_output_report: '研究报告',
      feat_output_mindmap: '思维导图',
      feat_output_cards: '闪卡',
      feat_output_quiz: '测验',
      feat_output_infographic: '信息图',
      feat_output_ppt: 'PPT',
      feat_output_podcast: '音频',
      feat_output_wiki: 'Wiki',
      feat_output_video: '视频',
    },
    edit_profile: {
      title: '修改信息',
      back: '返回',
      edit_user_info: '编辑用户信息',
      username: '用户名',
      email: '邮箱',
      company: '公司',
      save: '保存',
      change_password: '修改密码',
      current_password: '当前密码',
      new_password: '新密码',
      confirm_password: '确认新密码',
      user_info_update_success: '用户信息更新成功',
      update_failed: '更新失败：',
      update_failed_retry: '更新失败，请稍后重试',
      password_mismatch: '新密码和确认密码不一致',
      password_length_min: '密码长度至少为6位',
      password_update_success: '密码修改成功',
      password_update_failed: '密码修改失败：',
      password_update_failed_retry: '密码修改失败，请稍后重试',
      edit_profile: '修改信息'
    },
    order_center: {
      loading: '加载中...',
      no_orders: '暂无订单信息',
      order_id: '订单号',
      product: '产品',
      amount: '金额',
      payment_method: '支付方式',
      created_at: '创建时间',
      paid_at: '支付时间',
      status_pending: '待支付',
      status_paid: '已支付',
      status_failed: '支付失败',
      status_refunded: '已退款',
      alipay: '支付宝'
    }
  },
  'en': {
    header: {
      home: 'Home',
      features: 'Features',
      blog: 'Blog',
      download: 'Download',
      buy: 'Buy',
      token: 'Token Plan',
      contact: 'Contact Us',
      user:"User",
      edit_profile: 'Edit Profile',
      order_center: 'Order Center'
    },
    features: {
      title: 'Core Features',
      subtitle: 'Omni-note core capabilities to upgrade your knowledge workflow',
      heroTitle: 'Powerful Features, Ready Out of Box',
      heroSubtitle: 'Data stays on your device — from knowledge production to content generation, fully trusted and controllable',

      agentEngine: '9 Structured Output Engines',
      agentEngineDesc: 'Knowledge base results go beyond text answers — Omni-note includes 9 structured output engines: research reports, mind maps, flashcards, quizzes, infographics, Wiki articles, PPT outlines, podcasts, and videos. Upload materials, ask questions, and AI generates structured deliverables directly — from knowledge to output in one step.',
      agentEngineHighlight: 'Reports / Mind Maps / Flashcards / Quizzes / Infographics / Wiki / PPT / Podcasts / Videos — one-click deliverables',
      rag: 'Graph RAG Knowledge Base',
      ragDesc: 'Upload documents (PDF, Word, Markdown, code), AI auto-parses and indexes to build your private knowledge base. Graph RAG triple RRF fusion retrieval — BM25 keywords + vector search + Knowledge Graph (entity extraction + community clustering) — with ReAct Agent intelligent orchestration (auto-decompose complex questions, multi-step reasoning, dynamic MCP tool calls) for precise answers with source citations, no AI hallucinations.',
      ragHighlight: 'Triple RRF Fusion + ReAct Agent orchestration, far more accurate than traditional RAG',

      multimodal: 'Multimodal AI Processing',
      multimodalDesc: 'Supports text, images, audio, video. Local image generation, speech transcription, video frame analysis — break the limits of single modality.',
      multimodalHighlight: 'A regular computer, full media coverage',

      mcp: 'Agent Infinite Extension Platform',
      mcpDesc: 'Connect 5000+ agents via MCP protocol. Need data analysis, code review, financial reports, AI customer service? Install the agent and use it immediately — no development needed.',
      mcpHighlight: 'Your needs, not your limits',

      notes: 'Smart Note Management',
      notesDesc: 'Markdown editor, multi-level folder tree, template system — build a complete knowledge organization system. Recycle bin, full-text search. Find answers fast.',
      notesHighlight: 'Structured organization, search on demand — knowledge never scattered',

      security: 'Private & Secure Deployment',
      securityDesc: '100% local deployment, data never leaves your computer. End-to-end database encryption, zero cloud leakage risk. Ideal for finance, healthcare, research.',
      securityHighlight: 'Data security is architecture, not belief',

      deploy: 'Flexible Deployment',
      deployDesc: 'C/S architecture supports 3 modes: standalone PC, LAN team collaboration, cloud hybrid. Cross-platform (Windows/macOS/Linux) seamless sync.',
      deployHighlight: 'One platform, all your devices',

      api: 'Standardized API Compatible',
      apiDesc: 'Unified interfaces for mainstream services: OpenAI API, FUNASR speech, Stable Diffusion image gen, Jina AI rerank. Seamless ecosystem integration.',
      apiHighlight: 'No vendor lock-in, free model switching',

      cta: 'Ready to Experience?',
      ctaDesc: 'Download free and experience the full-chain secure & trusted AI knowledge platform',
    },
    download: {
      title: 'Download Omni-note',
      subtitle: 'Get started with our AI productivity platform today',
      chooseVersion: 'Choose Version',
      selectEdition: 'Select the edition that fits your needs',
      personalEdition: 'Personal Edition',
      enterpriseEdition: 'Enterprise Edition',
      personalDownload: 'Personal Edition Download',
      personalDesc: 'Free version for individual users and small teams',
      enterpriseDownload: 'Enterprise Edition Download',
      enterpriseDesc: 'Advanced version for business users with additional features and support',
      choosePlatform: 'Choose Your Platform',
      downloadFor: 'Download for',
      windows: 'Windows',
      macos: 'macOS',
      linux: 'Linux',
      windowsDesc: 'Windows 10 or later',
      macosDesc: 'macOS 10.15 or later',
      linuxDesc: 'Ubuntu 20.04 or later',
      systemRequirements: 'System Requirements',
      windowsRequirements: 'Windows Requirements',
      macosRequirements: 'macOS Requirements',
      linuxRequirements: 'Linux Requirements',
      minRam: '4 GB RAM minimum',
      processor: '2 GHz processor or faster',
      diskSpace: '1 GB disk space (excluding model files)',
      enterpriseFeatures: 'Enterprise Features',
      enterpriseTitle: 'Enterprise Edition',
      advancedSecurity: 'Advanced Security',
      multiUserSupport: 'Multi-user Support',
      centralizedManagement: 'Centralized Management',
      dedicatedSupport: 'Dedicated Support',
      osRequirements: 'Supported OS',
      hardwareRequirements: 'Hardware Requirements',
      needMore: 'Need more features or custom solutions?',
      contactSales: 'Contact Sales Team'
    },
    home: {
      // ===== Hero =====
      title: 'Omni-note',
      subtitle: 'Full-Chain Secure & Trusted AI Knowledge Platform',
      heroDesc: 'Local keeps data on your machine; Cloud runs out of the box — from knowledge production to content generation, fully trusted and under your control.',
      download: 'Download Free',
      watchDemo: 'Watch Demo',
      contactUs: 'Contact Us',

      // ===== Editions =====
      editionsTitle: 'Two Editions, Pick What Fits',
      editionsSubtitle: 'Same features — different data location and billing; both include a native Chinese UI',
      localTitle: 'Local Edition',
      localTag: 'Data stays on your machine',
      localDesc: 'Models and inference run entirely on your computer — ideal for offline use or strict data privacy.',
      localFeature1: 'Data and inference stay on your machine',
      localFeature2: 'Works offline, no external network needed',
      localFeature3: 'Membership tiers differ by monthly usage',
      localFeature4: 'Requires model downloads and inference setup',
      localCta: 'View Local Edition',
      cloudTitle: 'Cloud Edition',
      cloudTag: 'Runs out of the box',
      cloudDesc: 'Free software with pay-as-you-go model billing — ideal for light devices or a quick start.',
      cloudFeature1: 'Download and run — no local models or inference setup',
      cloudFeature2: 'Calls cloud models via api.turingevo.com',
      cloudFeature3: 'No monthly call limits — pay only for what you use',
      cloudFeature4: 'No local compute needed — works on light devices',
      cloudCta: 'View Cloud Edition',

      // ===== 3 Core Values =====
      valueTitle: 'Why Choose Omni-note?',
      valueSubtitle: 'Full-chain, secure & trusted — Knowledge Production · Knowledge Management · Content Generation, the complete knowledge workflow',

      valueRag: 'Graph RAG Knowledge Base',
      valueRagDesc: 'Upload documents, AI reads, indexes, and answers. Graph RAG triple RRF fusion retrieval (BM25 keywords + vector search + Knowledge Graph with entity extraction + community clustering), with ReAct Agent intelligent orchestration — auto-decompose complex questions and multi-step reasoning. Far more accurate than single-vector search. Every answer comes with clear source citations.',
      valueRagStat: 'BM25 + Vectors + Knowledge Graph · Triple RRF Fusion · ReAct Agent · Traceable citations',

      valuePrivate: 'Local Private Deployment',
      valuePrivateDesc: 'Data never leaves your computer. End-to-end database encryption, zero cloud leakage risk. Runs on CPU alone — no expensive GPU needed. A regular laptop is all it takes.',
      valuePrivateStat: 'CPU only · End-to-end encryption · 70%+ cost savings',

      valueMcp: 'Multimodal + Agent Extension',
      valueMcpDesc: 'Full modality AI processing: text, image, audio, video (local image generation, speech transcription, video frame analysis). Connect 5000+ agents via MCP protocol — extend on demand, no development needed.',
      valueMcpStat: 'Image/Audio/Video · 5000+ agents · Plug and play',

      // ===== Demo Video =====
      demoTitle: 'See Omni-note in 3 Minutes',
      demoSubtitle: 'A real screen recording, from importing sources to nine types of output',
      demoCaption: 'The demo is narrated in Chinese. An English version is in production.',

      // ===== Nine Outputs =====
      outputsTitle: 'From Knowledge to Deliverables',
      outputsSubtitle: 'Upload your sources and let AI generate nine structured deliverables — from research reports to podcasts and explainer videos',
      outputReport: 'Research Report',
      outputReportDesc: 'Deep, citation-backed reports built from your knowledge base',
      outputMindmap: 'Mind Map',
      outputMindmapDesc: 'Break a topic into branches and see the whole picture at a glance',
      outputPpt: 'PPT Outline',
      outputPptDesc: 'Organize key points into a presentation flow, ready to build',
      outputWiki: 'Wiki Article',
      outputWikiDesc: 'Turn sources into structured knowledge entries with multi-level sections',
      outputAudio: 'Podcast',
      outputAudioDesc: 'Two-host conversational audio you can absorb on the go',
      outputVideo: 'Video',
      outputVideoDesc: 'Generated narration and visuals that turn sources into a video',
      outputQuiz: 'Quiz',
      outputQuizDesc: 'Questions generated from your sources, with answers and explanations',
      outputCards: 'Flashcards',
      outputCardsDesc: 'Two-sided knowledge cards for memorization and review',
      outputInfographic: 'Infographic',
      outputInfographicDesc: 'Turn key data and relationships into a visual chart',

      // ===== Version Comparison =====
      versionComparison: 'Version Comparison',
      chooseBestPlan: 'Find the right plan for you',

      features: 'Features',
      communityEdition: 'Community',
      enterpriseEdition: 'Enterprise',
      membershipEdition: 'Premium',

      openSourceLicense: 'License',
      openSource: 'Free',
      commercialLicense: 'Commercial License',
      cost: 'Cost',
      freePersonal: 'Free for personal',
      oneTimePurchase: '¥19/mo or ¥119/yr',
      deployment: 'Deployment',
      singleMachine: 'Single machine',
      privateDeployment: 'Private deployment',

      function: 'Features',
      basicFeatures: 'Basic features',
      modelManagement: 'Model management',
      employeeManagement: 'User management',
      sharedKnowledge: 'Shared knowledge base',
      dataBackup: 'Data backup',
      permissionControl: 'Permission control',

      technicalSupport: 'Support',
      communitySupport: 'Community support',
      dedicatedSupport: 'Dedicated support',

      systemSupport: 'System Support',
      win10Plus: 'Windows 10+, macOS, Linux',
      win7Plus: 'Windows 7+, macOS, Linux',

      // ===== Use Cases =====
      useCases: 'Use Cases',
      useCasesDesc: 'How Omni-note can work for you and your team',
      case1: '📚 Learning',
      case1Desc: 'From passive reading to active mastery',
      case1Detail: 'Upload class materials, textbooks, and notes. AI summarizes key points, generates Q&A flashcards, and enables semantic search — turning knowledge into yours.',
      case2: '🔬 Research',
      case2Desc: 'From finding information to uncovering insights',
      case2Detail: 'Upload research papers, get instant semantic retrieval across documents. AI synthesizes literature with citation tracing — no hallucinations, faster reports.',
      case3: '💼 Sales',
      case3Desc: 'From research to pitch preparation',
      case3Detail: 'Upload client info, product docs, and competitor analysis. AI builds buyer profiles, agents help draft pitches and sales scripts. Win on preparation.',
      case4: '🎯 Customer Support',
      case4Desc: 'From help docs to self-serve answers',
      case4Detail: 'Feed help center articles, product docs, and FAQs into your private knowledge base. Build a RAG system so staff and customers find answers instantly.',
      case5: '🚀 Team Onboarding',
      case5Desc: 'From manuals to interactive training',
      case5Detail: 'Combine employee handbooks, SOPs, and training videos into a shared knowledge base. New hires get instant answers, HR saves hours of repeated explanations.',
      case6: '✍️ Content Creation',
      case6Desc: 'From raw materials to multimodal output',
      case6Detail: 'Upload materials, generate images locally, transcribe audio, analyze video frames — turn inspiration into articles, illustrations, research reports, mind maps, PPT outlines, podcasts, and videos.',

      // ===== CTA =====
      ctaTitle: 'Ready for Omni-note?',
      ctaDesc: 'Sign up free and experience all core features',
      ctaStart: 'Get Started',
      ctaContact: 'Request Demo',

      honor: 'Honors & Industry Recognition',
      honorDesc: 'Recognized by ARM, Intel and Qualcomm — the three major chip platforms, with a special award from Lenovo',
      honorArm: 'ARM 2024 AI Innovation Application Contest · Excellence Award',
      honorIntel: 'Intel 2025 AI Innovation Application Contest · Winning Award',
      honorLenovo: 'Lenovo Title Sponsor · Special Award',
      honorQualcomm: 'Qualcomm Snapdragon 2025 AI Innovation Contest · Excellence Award',
      heroCardTitle: 'Omni-note',
      heroCardAi1: 'Analyzed 24 documents you uploaded. Ready for questions.',
      heroCardYou: 'You',
      heroCardQuestion: 'What is the core conclusion of this paper?',
      heroCardAnswer: 'According to Section 3.2 of "2025 AI Trends", the core conclusion is...',
      heroCardSource: '📄 Source: 2025_AI_Trends.pdf → Ch.3 → Sec.2',
    },
    purchase: {
      title: 'Choose Your Edition',
      subtitle: 'Cloud runs out of the box — free software with pay-as-you-go models. Local keeps all data and inference on your machine.',
      // ===== Editions =====
      editionsTitle: 'Two Editions, Pick What Fits',
      editionsSubtitle: 'Cloud is download-and-run with usage-based model billing. Local runs models on your own machine, so data never leaves it.',
      cloudTitle: 'Cloud Edition',
      cloudTag: 'Recommended · No local models',
      cloudDesc: 'The software is free forever. Model usage is billed by tokens and topped up on the API platform.',
      cloudFeature1: 'Download and run — no inference engine or model downloads',
      cloudFeature2: 'Calls cloud models via api.turingevo.com',
      cloudFeature3: 'No monthly call limits — pay only for what you use',
      cloudFeature4: 'Linux available now; Windows / macOS coming soon',
      cloudDownload: 'Download on GitHub',
      cloudRecharge: 'Recharge on API Platform',
      localTitle: 'Local Edition',
      localTag: 'All data stays local',
      localPrice: 'Membership',
      localDesc: 'Models and inference run on your machine — ideal for offline use or strict data privacy.',
      localFeature1: 'Local models, data never leaves your machine',
      localFeature2: 'Membership tiers differ by monthly usage limits',
      localFeature3: 'Requires model downloads and inference setup',
      localFeature4: 'Community / Basic / Pro / Enterprise',
      localViewPlans: 'View Local Plans',

      free: 'Free',
      buyNow: 'Buy Now',
      contactSales: 'Contact Sales',
      custom: 'Custom',
      monthlyLabel: 'Monthly',
      yearlyLabel: 'Yearly',

      communityTitle: 'Community',
      communityDesc: 'For personal projects',
      communityFeature1: '3 KBs · 50 docs each',
      communityFeature2: 'Image gen 30/mo',
      communityFeature3: 'Speech 25/mo',
      communityFeature4: 'Video analysis 20/mo',
      communityFeature5: 'Basic agents 3',
      communityFeature6: 'Advanced export 5/mo',
      communityFeature7: 'Community support',
      downloadNow: 'Download Free',

      basicTitle: 'Basic',
      basicPrice: '¥9.9',
      basicOriginalPrice: '¥19',
      basicPerMonth: '/mo',
      basicDesc: 'For active learning and deep research',
      basicFeature1: '5 KBs · 80 docs each',
      basicFeature2: 'Image gen 100/mo',
      basicFeature3: 'Speech 75/mo',
      basicFeature4: 'Video analysis 60/mo',
      basicFeature5: 'Basic agents 10',
      basicFeature6: 'Advanced export 15/mo',
      basicFeature7: 'Community support',

      proTitle: 'Pro',
      proBadge: 'Most Popular',
      proDesc: 'For the most demanding projects and power users',
      proMonthly: '¥19',
      proYearly: '¥119',
      proPerMonth: '/mo',
      proPerYear: '/yr',
      proMonthlyOriginal: '¥39',
      proYearlyOriginal: '¥199',
      proSave: 'Save ¥109',
      proFeature1: 'KB/Docs unlimited',
      proFeature2: 'Image/Speech/Video unlimited',
      proFeature3: 'Agents unlimited',
      proFeature4: 'Advanced export unlimited',
      proFeature5: 'Priority support',

      enterpriseTitle: 'Enterprise',
      enterpriseDesc: 'Team collaboration, private deployment, dedicated support',
      enterpriseFeature1: 'Unlimited users & devices',
      enterpriseFeature2: 'Shared KB · Permissions',
      enterpriseFeature3: 'PC / LAN / Cloud deployment',
      enterpriseFeature4: 'Dedicated account manager',
      enterpriseFeature5: '24/7 premium support + custom dev',

      // ===== Comparison Tables =====
      editionCompareTitle: 'Cloud vs Local',
      editionCompareSubtitle: 'Both editions share the same features; they differ in model source, cost and usage limits.',
      compareItem: 'Item',
      compareModelSource: 'Model source',
      compareCloudModelSource: 'Cloud API (api.turingevo.com)',
      compareLocalModelSource: 'On-device inference (local models)',
      compareCost: 'Cost',
      compareCloudCost: 'Free software + pay-as-you-go tokens',
      compareLocalCost: 'Membership + your own hardware',
      compareUsageLimit: 'Monthly limits',
      compareCloudUsage: 'None — billed by actual usage',
      compareLocalUsage: 'Depends on plan (see below)',
      compareSetup: 'Setup',
      compareCloudSetup: 'Download and run',
      compareLocalSetup: 'Local models and inference required',

      localPlansTitle: 'Local Edition Plans',
      localPlansNote: 'The monthly limits below apply to the Local Edition only. The Cloud Edition has no local usage limits — model costs are billed by API usage.',
      compareTitle: 'Local Edition Plan Comparison',
      compareSubtitle: 'These limits apply to the Local Edition only. The Cloud Edition is not subject to them.',
      features: 'Features',
      ragBasic: 'RAG Knowledge Base',
      modelSwitch: 'Model Switching',
      knowledgeBaseCount: 'Knowledge Bases',
      docPerKb: 'Docs per KB',
      imageGen: 'Image Generation',
      audioTranscribe: 'Speech-to-Text',
      videoAnalyze: 'Video Analysis',
      agentCount: 'Agents',
      advancedExport: 'Advanced Export',
      teamCollab: 'Team Collaboration',
      sharedKb: 'Shared KB',
      userMgmt: 'User Management',
      support: 'Support Level',
      unlimited: '∞',
      limitImageGen: '30/mo',
      limitAudioTranscribe: '25/mo',
      limitVideoAnalyze: '20/mo',
      limitExportGen: '5/mo',
      limitAgent: '3',
      basicExport: 'Basic',
      basicLimitImageGen: '100/mo',
      basicLimitAudioTranscribe: '75/mo',
      basicLimitVideoAnalyze: '60/mo',
      basicLimitExportGen: '15/mo',
      basicLimitAgent: '10',

      // ===== CTA =====
      ctaTitle: 'Need a custom plan for your team?',
      ctaSubtitle: 'Request a demo to see how Omni-note can power up your organization',
      requestDemo: 'Request a Demo',

      // ===== FAQ =====
      faqTitle: 'FAQ',
      faqQ1: 'What\'s the difference between Community, Basic and Pro in the Local Edition?',
      faqA1: 'Local plans share the same features — only monthly usage limits differ. Community: 30 image gens, 25 speech, 20 video analyses per month. Basic: 100/75/60. Pro removes all limits. The Cloud Edition has none of these limits; model costs are billed by API usage on api.turingevo.com.',
      faqQ2: 'How to upgrade?',
      faqA2: 'Click "Buy Now" to upgrade your Local Edition membership. Launch promotion is on now (Pro ¥39 → ¥19).',
      faqQ3: 'Should I choose Cloud or Local?',
      faqA3: 'Choose Cloud for download-and-run simplicity and pay-as-you-go pricing (free software, recharge on the API platform). Choose Local if you need offline use or data must stay on your machine — it requires downloading models and setting up inference, and uses the membership plans.',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      getInTouch: 'Get in Touch',
      wedLove: 'We\'d love to hear from you',
      contactInfo: 'Contact Information',
      name: 'Name',
      details: 'Details',
      qqGroup: 'QQ Group',
      telegram: 'Telegram Group',
      website: 'Official Website',
      email: 'Email',
      blog: 'Blog',
      csdn: 'CSDN',
      github: 'GitHub',
      huggingface: 'Hugging Face',
      enterpriseWechat: 'Enterprise WeChat',
      officialAccount: 'WeChat Official Account',
      videoChannel: 'Video Channel',
      sendMessage: 'Send us a Message',
      fillForm: 'Fill out the form below and we\'ll get back to you as soon as possible',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...'
    },
    footer: {
      description: 'Omni-note is a full-chain secure and trusted AI knowledge platform — Local keeps data on your machine, Cloud runs out of the box, from knowledge production to content generation.',
      socialLinks: 'Social Links',
      product: 'Product',
      documentation: 'Documentation',
      feedback: 'Feedback',
      friendlyLinks: 'Friendly Links',
      contactUs: 'Contact Us',
      officialAccount: 'Official WeChat Account',
      questions: 'If you have any questions, you can check the documentation or ask in the community first. Or email us at',
      copyright: 'Copyright © 2026 Shenzhen Turing Evo Intelligent Technology Co., Ltd. turingevo.com'
    },
    register: {
      title: 'User Registration',
      username: 'Username',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      company: 'Company',
      placeholder_username: 'Please enter username',
      placeholder_email: 'Please enter email',
      placeholder_password: 'Please enter password',
      placeholder_confirm_password: 'Please enter password again',
      register: 'Register',
      registering: 'Registering...',
      already_have_account: 'Already have an account?',
      login_now: 'Login now',
      error_user_exists: 'This username or email has been registered, please choose another username or email',
      error_password_length: 'Password length must be at least 6 characters',
      error_invalid_email: 'Please enter a valid email address',
      error_generic: 'Registration failed, please try again later',
      error_password_mismatch: 'The passwords entered twice do not match',
      error_missing_fields: 'Username, email and password are required',
      error_server_internal: 'Server internal error'
    },
    login: {
      title: 'User Login',
      email: 'Email',
      password: 'Password',
      placeholder_email: 'Please enter email',
      placeholder_password: 'Please enter password',
      login: 'Login',
      logging_in: 'Logging in...',
      dont_have_account: 'Don\'t have an account?',
      register_now: 'Register now',
      error_user_not_found: 'This user does not exist, please register first',
      error_password_wrong: 'Incorrect password, please try again',
      error_generic: 'Login failed, please try again later',
      registration_success: 'Registration successful! Please log in.'
    },
    profile: {
      title: 'Profile',
      logout: 'Logout',
      user_info: 'User Information',
      username: 'Username',
      email: 'Email',
      company: 'Company',
      license_info: 'License Information',
      license_type: 'License Type',
      license_community: 'Community',
      license_basic: 'Basic',
      license_pro: 'Pro',
      license_enterprise: 'Enterprise',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      expiry_date: 'Expiry Date',
      devices: 'Devices',
      license_key: 'License Key',
      show_key: 'Show Key',
      hide_key: 'Hide Key',
      copy_key: 'Copy Key',
      upgrade_to_enterprise: 'Upgrade to Enterprise',
      no_license: 'No license information',
      features: 'Features',
      usage_info: 'Usage',
      usage_image_gen: 'Image Generation',
      usage_speech_asr: 'Speech-to-Text',
      usage_video_analyze: 'Video Analysis',
      usage_report_gen: 'Research Report',
      usage_mindmap_gen: 'Mind Map',
      usage_cards_gen: 'Flashcards',
      usage_quiz_gen: 'Quiz',
      usage_infographic_gen: 'Infographic',
      usage_ppt_gen: 'PPT',
      usage_podcast_gen: 'Podcast',
      usage_wiki_gen: 'Wiki',
      usage_video_gen: 'Video',
      usage_unlimited: 'Unlimited',
      usage_times: '',
      usage_of: ' / ',
      usage_agent_limit: 'Agents',
      usage_kb_limit: 'Knowledge Bases',
      usage_doc_limit: 'Docs / KB',
      usage_limit_unit: '',
      usage_doc_unit: '',
      feat_basic_note: 'Basic Notes',
      feat_rag_basic: 'Basic RAG',
      feat_rag_medium: 'Intermediate RAG',
      feat_rag_pro: 'Pro RAG',
      feat_image_gen: 'Image Generation',
      feat_speech_asr: 'Speech-to-Text',
      feat_agent_basic: 'Basic Agent',
      feat_agent_medium: 'Intermediate Agent',
      feat_agent_pro: 'Pro Agent',
      feat_premium_support: 'Premium Support',
      feat_team_collab: 'Team Collab',
      feat_shared_kb: 'Shared KB',
      feat_user_mgmt: 'User Management',
      feat_output_report: 'Research Report',
      feat_output_mindmap: 'Mind Map',
      feat_output_cards: 'Flashcards',
      feat_output_quiz: 'Quiz',
      feat_output_infographic: 'Infographic',
      feat_output_ppt: 'PPT',
      feat_output_podcast: 'Podcast',
      feat_output_wiki: 'Wiki',
      feat_output_video: 'Video',
    },
    edit_profile: {
      title: 'Edit Profile',
      back: 'Back',
      edit_user_info: 'Edit User Information',
      username: 'Username',
      email: 'Email',
      company: 'Company',
      save: 'Save',
      change_password: 'Change Password',
      current_password: 'Current Password',
      new_password: 'New Password',
      confirm_password: 'Confirm New Password',
      user_info_update_success: 'User information updated successfully',
      update_failed: 'Update failed: ',
      update_failed_retry: 'Update failed, please try again later',
      password_mismatch: 'New password and confirm password do not match',
      password_length_min: 'Password length must be at least 6 characters',
      password_update_success: 'Password updated successfully',
      password_update_failed: 'Password update failed: ',
      password_update_failed_retry: 'Password update failed, please try again later'
    },
    order_center: {
      loading: 'Loading...',
      no_orders: 'No order information',
      order_id: 'Order ID',
      product: 'Product',
      amount: 'Amount',
      payment_method: 'Payment Method',
      created_at: 'Created At',
      paid_at: 'Paid At',
      status_pending: 'Pending',
      status_paid: 'Paid',
      status_failed: 'Failed',
      status_refunded: 'Refunded',
      alipay: 'Alipay'
    }
  }
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: 'zh-CN', // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages // 语言包
})

export default i18n
